import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom';
import { useRouter } from 'next/navigation';
import Modal from '.';
import BorderButton from '../Forms/BorderButton';
import GradientButton from '../Forms/GradientButton';
import { CloseModalSVG, LoaderSVG } from '../SVGs/CommonSVG';
import Subscription from '@/Component/Brand/Subscription';

const LimitExceedModal = (props) => {
    const { modal, setModal, loader, args, translations, campaignDetailRefetch } = props
    const router = useRouter();

    const [mounted, setMounted] = useState(false);

    useEffect(() => setMounted(true), []);

    return mounted ? createPortal(
        <Modal modalSize="md:w-3/2 w-1/1" modal={modal} setModal={setModal} childMainClass="max-h-[90vh] overflow-y-auto">
            <div>
                <button className="absolute -top-4 -right-4 " onClick={() => setModal(null)}>
                    <CloseModalSVG />
                </button>
                {/* <h3 className="mb-6 text-xl font-medium">
                    {args?.message}
                </h3>
                <div className="flex justify-center gap-2">
                    <GradientButton customClass={'flex items-center justify-center !w-full'} onClick={callbackFunction}>
                        {translations?.becomePremium} {loader && <LoaderSVG customClass='ml-2.5' />}
                    </GradientButton>
                </div> */}
                <Subscription setPremiumModal={setModal} listRefetch={campaignDetailRefetch} />
            </div>
        </Modal>
        , document.body) : null;
}

export default LimitExceedModal
